export const InputPatterns = {
	EMAIL: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,

	PASSWORD: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/,

	ACCOUNT_NUMBER: /^\d{10}$/,

	MOBILE_NO: /^\+*\d{9,13}$/,

	NAME_FIELD: /^[A-Za-z0-9][A-Za-z0-9 ]*[A-Za-z0-9]$/,

	USERNAME_POLICY: /^(?=[a-zA-Z0-9-._@]{6,50}$)(?!.*[-_.@]{2})[^-_.@].*[^-_.@]$/,

	NIGERIA_MOBILE_NO:
		/((^090)([12356789]))|((^070)([1-9]))|((^080)([2-9]))|((^090)([12356789]))|((^070)([1-9]))|((^080)([2-9]))|((^081)([0-9]))(\d{7})|((^091)([0-9]))(\d{7})/,
	
	CAC_NUMBER:  /^0{7}$|^(?![0]+$)[A-Z]+[A-Z0-9]{0,7}$/i,
	
	ALPHA_NUMERIC: /[a-zA-Z0-9]$/
};
